/* Constants */
import { REMOTE_TRUE, CUSTOM_DROPDOWN_OPTIONS } from '@scenes/AddSkuPage/addsku.constants';

/* Utils */
import { isValidObjectWithKeys } from '@utils/object';

/* This function answers the question, Does the partners pay for add-ons, or is it the customer's responsibility? */
export const isPartnerSubsidizedAddOn = ({ answer, sku }) => answer.subsidizedToPartner && !sku.subsidizingBasePriceOnly;

// DEVICE CATALOGING utils
// Get device make options
export const getDeviceMakeOptions = (question, sku) =>
  question.answers.map(a => {
    let label = a.text;
    const showAmount = a.adjAmountFormatted && !isPartnerSubsidizedAddOn({ answer: a, sku });

    if (a.id === REMOTE_TRUE) {
      if (typeof sku.remoteSavingsFormatted === 'string') {
        label = label.replace('%{SAVING}%', sku.remoteSavingsFormatted);
      }
    }
    if (showAmount) {
      const answerAdjAmountFormatted = a.adjAmountFormatted;
      const amount = isValidObjectWithKeys(answerAdjAmountFormatted) ? answerAdjAmountFormatted?.formatted || '(Error)' : answerAdjAmountFormatted;

      label += ` (+${amount})`;
    }
    return { value: a.id, label };
  });

// Get device model options
export const getDeviceModelOptions = ({ products }) => {
  if (products) {
    const modelOptions = products.answers.map(p => ({ value: p.id, label: p.name }));
    // push custom options 'other' & 'idk'
    modelOptions.push(CUSTOM_DROPDOWN_OPTIONS.OTHER);
    modelOptions.push(CUSTOM_DROPDOWN_OPTIONS.I_DONT_KNOW);
    return modelOptions;
  }
  return null;
};

export const getSelectedModel = ({ questionAnswers, valueId }) => {
  const selectedModel = questionAnswers.find(a => {
    if (!a.productQuestion) return null;
    return valueId === a.id && a.productQuestion.answers;
  });
  return selectedModel;
};

export const getModelQuestion = ({ answers }) => answers?.[0]?.productQuestion?.text;

/*
  function to check if value is string - if it is, that means it is an input field.
*/
export const isStringType = value => typeof value === 'string';
